import {
  ChevronDoubleLeft16Filled,
  ChevronLeft16Filled,
  ChevronRight16Filled,
  ChevronDoubleRight16Filled,
  Add16Filled,
  Delete16Filled,
} from '@fluentui/react-icons';
import type { RepeatingPanelAction } from '@moko/utils';

export const repeatingPanelIcons: Record<
  RepeatingPanelAction,
  React.ReactElement
> = {
  first: <ChevronDoubleLeft16Filled />,
  prev: <ChevronLeft16Filled />,
  next: <ChevronRight16Filled />,
  last: <ChevronDoubleRight16Filled />,
  add: <Add16Filled />,
  remove: <Delete16Filled />,
};

export const VALUE_COLUMN_FIXED_WIDTH = 250;

export const VALUE_UNIT_COLUMN_STYLE = { width: 150, minWidth: 150 };

export const VALUE_WITH_UNIT_COLUMN_STYLE = { width: 100 };

export const FIELD_STYLE = {
  width: '100%',
  maxWidth: 350,
  textAlign: 'left' as const,
};
